<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <span class="text-h4">Justificar Falta</span>
        <e-help-tooltip
          text="Gerencie e registre novas justificativas de faltas, podendo consultar documentos anexados e verificar a análise das solicitações."
        />
        <v-col cols="12" class="pt-2 px-0">
          <div class="d-flex justify-space-between flex-wrap">
            <v-btn color="success" class="mr-2 mb-2" @click="abrirCriar">
              Criar Justificativa
            </v-btn>
            <v-text-field
              v-model="search"
              class="mb-2 search-input"
              append-icon="mdi-magnify"
              label="Pesquisar aluno..."
              solo
              dense
              single-line
              hide-details
            />
          </div>
        </v-col>
      </v-col>
    </v-row>

    <v-tabs v-model="abaIndex">
      <v-tab>Todas as justificativas</v-tab>
      <v-tab>Minhas justificativas Criadas</v-tab>
    </v-tabs>

    <v-row>
      <v-col class="pt-4">
        <v-data-table
          :headers="table.headers"
          :items="justificativas"
          :loading="carregando"
          :items-per-page="10"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:item.alunoTurma="{ item }">
            <div>{{ item.aluno ? item.aluno.nomecompleto : "---" }}</div>
            <div class="text-caption text--secondary">
              {{ item.matricula && item.matricula.turma ? item.matricula.turma.descricao : "---" }}
            </div>
          </template>
          <template v-slot:item.tipo="{ item }">
            {{ tipoLabel(item.tipo) }}
          </template>
          <template v-slot:item.periodo="{ item }">
            {{
              item.data_inicial
                ? `${formatarData(item.data_inicial)} a ${formatarData(item.data_final)}`
                : "---"
            }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  small
                  label
                  :color="statusInfo(item.status).color"
                  text-color="white"
                  @click="abrirDetalhes(item.id)"
                >
                  {{ statusInfo(item.status).label }}
                </v-chip>
              </template>
              <span>Você pode alterar o status da justificativa com base na sua análise</span>
            </v-tooltip>
          </template>
          <template v-slot:item.historico="{ item }">
            <v-btn icon small @click="abrirHistorico(item)">
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip color="blue-grey" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  class="ml-1"
                  color="blue-grey lighten-3"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="item.status !== 'AGUARDANDO'"
                  @click="abrirEditar(item.id)"
                >
                  <v-icon small>fa fa-edit</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip color="error" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  class="ml-1"
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="item.status !== 'AGUARDANDO'"
                  @click="destroy(item.id)"
                >
                  <v-icon small>fa fa-trash</v-icon>
                </v-btn>
              </template>
              <span>Deletar</span>
            </v-tooltip>
            <!-- <v-tooltip color="primary" bottom v-if="item.anexo">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  class="ml-1"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="imprimirAtestado(item.id)"
                >
                  <v-icon small>fa fa-print</v-icon>
                </v-btn>
              </template>
              <span>Imprimir atestado</span>
            </v-tooltip> -->
          </template>
        </v-data-table>
        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          :search="search"
          @changeActionResponse="loadData"
        ></e-paginate>
      </v-col>
    </v-row>

    <FormJustificativaFaltaDialog
      v-model="dialogForm"
      :editing-id="editingId"
      @salvo="loadData(pageNumber)"
    />
    <DetalhesAnaliseJustificativaDialog
      v-model="dialogDetalhes"
      :justificativa-id="detalhesId"
      @salvo="loadData(pageNumber)"
    />
    <HistoricoJustificativaFaltaDialog
      v-model="dialogHistorico"
      :solicitacao="historicoSelecionado"
    />
  </main-template>
</template>

<script>
import FormJustificativaFaltaDialog from "./FormJustificativaFaltaDialog.vue";
import DetalhesAnaliseJustificativaDialog from "./DetalhesAnaliseJustificativaDialog.vue";
import HistoricoJustificativaFaltaDialog from "./HistoricoJustificativaFaltaDialog.vue";

const STATUS = {
  AGUARDANDO: { label: "Aguardando", color: "grey" },
  CONFIRMADO: { label: "Confirmado", color: "green" },
  REJEITADO: { label: "Rejeitado", color: "red" },
};

const TIPOS_LABEL = {
  SAUDE: "Motivos de saúde",
  VIAGEM: "Motivos de viagem",
  ATESTADO_MEDICO: "Atestado médico",
  OUTROS: "Outros",
};

export default {
  components: {
    FormJustificativaFaltaDialog,
    DetalhesAnaliseJustificativaDialog,
    HistoricoJustificativaFaltaDialog,
  },
  computed: {
    aba() {
      return this.abaIndex === 1 ? "minhas" : "todas";
    },
  },
  data() {
    return {
      justificativas: [],
      carregando: false,
      search: "",
      abaIndex: 0,
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      dialogForm: false,
      editingId: null,
      dialogDetalhes: false,
      detalhesId: null,
      dialogHistorico: false,
      historicoSelecionado: null,
      table: {
        headers: [
          { text: "ID", value: "id" },
          { text: "Aluno/Turma", value: "alunoTurma" },
          { text: "Justificativa", value: "tipo" },
          { text: "Data Justificativa", value: "periodo" },
          { text: "Status", value: "status" },
          { text: "Histórico", value: "historico", sortable: false },
          { text: "Ações", value: "actions", sortable: false, width: "150px" },
        ],
      },
    };
  },
  watch: {
    search() {
      this.loadData(0);
    },
    aba() {
      this.loadData(0);
    },
  },
  methods: {
    statusInfo(status) {
      return STATUS[status] || { label: "- - -", color: "grey" };
    },
    tipoLabel(tipo) {
      return TIPOS_LABEL[tipo] || tipo;
    },
    formatarData(data) {
      if (!data) return "---";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    abrirCriar() {
      this.editingId = null;
      this.dialogForm = true;
    },
    abrirEditar(id) {
      this.editingId = id;
      this.dialogForm = true;
    },
    abrirDetalhes(id) {
      this.detalhesId = id;
      this.dialogDetalhes = true;
    },
    abrirHistorico(item) {
      this.historicoSelecionado = item;
      this.dialogHistorico = true;
    },
    async loadData(pageNumber = 0) {
      this.pageNumber = pageNumber;
      this.carregando = true;
      try {
        const response = await this.$services.justificativaFaltaService.syncAll(pageNumber, {
          query: this.search,
          aba: this.aba,
        });
        this.paginate = response;
        this.justificativas = response.data;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    async imprimirAtestado(id) {
      try {
        await this.$services.justificativaFaltaService.baixarAtestado(id);
      } catch (error) {
        this.$handleError(error);
      }
    },
    destroy(id) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja excluir esta justificativa?",
        confirmationCode: id,
        confirmationMessage: `Por favor, digite <strong>${id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              try {
                await this.$services.justificativaFaltaService.destroy(id);
                this.$toast.success("Justificativa excluída com sucesso");
                this.loadData(this.pageNumber);
              } catch (error) {
                this.$handleError(error);
              }
            },
            props: { color: "error", small: true },
          },
        ],
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
